import { render } from "./LandingView.vue?vue&type=template&id=06060f12&scoped=true&ts=true"
import script from "./LandingView.vue?vue&type=script&lang=ts"
export * from "./LandingView.vue?vue&type=script&lang=ts"

import "./LandingView.vue?vue&type=style&index=0&id=06060f12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06060f12"],['__file',"src/views/LandingView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06060f12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06060f12', __exports__)) {
    api.reload('06060f12', __exports__)
  }
  
  module.hot.accept("./LandingView.vue?vue&type=template&id=06060f12&scoped=true&ts=true", () => {
    api.rerender('06060f12', render)
  })

}


export default __exports__